//@flow
import * as Immutable from 'immutable';

import { Skill } from 'common/models/flow/Skill';
import type { SkillModelType } from 'common/models/flow/Skill';

import { EntityTeamMapping } from './EntityTeamMapping';

//Validation stuff
import {
    validatable,
    validate,
    validateAll,
    validateId,
    softValidateAll
} from 'common/utils/ValidationUtil';
import I18nHelper from 'common/helpers/I18nHelper';

const translationsNamespace = ['validations'];

const nsTranslate = I18nHelper.translate.bind(null, translationsNamespace);

@validatable
class InternalSkill extends Skill {
    static fromJS(json: SkillModelType): InternalSkill {
        const state: Object = Object.assign({}, json);
        state.teams = state.teams
            ? Immutable.List(state.teams).map(item =>
                  EntityTeamMapping.fromJS(item)
              )
            : state.teams;
        return new this(Immutable.Map(state));
    }

    @validateAll
    setAllValidationErrors(): this {
        return this;
    }

    @validate
    setId(id: string): this {
        return super.setId(id);
    }

    validateId() {
        return validateId(this.id);
    }

    @validate
    setName(name: string): this {
        return super.setName(name);
    }

    validateName() {
        if (!this.name || this.name.trim().length === 0) {
            return nsTranslate('skills.nameEmpty');
        }
    }

    @softValidateAll
    hasValidationErrors() {}

    get teams(): ?Immutable.List<EntityTeamMapping> {
        return this._state.get('teams');
    }
}

export { InternalSkill as Skill };
